import React, { useEffect, useState } from "react";
import "./Free_Consultation.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Solar_Modal from "../../common/solar-modal/Solar_Modal";
import { useNavigate } from "react-router-dom";

const Free_Consultation = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (showModal) {
  //     const timer = setTimeout(() => {
  //       setShowModal(false);
  //       navigate("/");
  //     }, 2500); 

  //     return () => clearTimeout(timer);
  //   }
  // }, [showModal]);

  return (
    <section className="Free_Consultation">
      <div className="container">
        <div className="Free_Consultation_div">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-5">
              <div className="Free_Consultation_img_holder">
                <img
                  src="/assets/images/book1.png"
                  alt="flower consultant"
                  className="Free_Consultation_img"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://images.unsplash.com/photo-1561181286-d3fee7d78ef4?w=400";
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="Free_Consultation_text_div">
                <h5 className="Free_Consultation_header">
                   Book Your <span>Free Event Consultation</span> Today
                </h5>

                <p className="Free_Consultation_text">
                 From dreamy weddings to vibrant birthdays, elegant engagements, and professional corporate events — we bring your vision to life with creativity and precision. Our expert team handles every detail, ensuring seamless planning and flawless execution.
                </p>

                <div
                  className="free_btn_holder"
                  onClick={() => setShowModal(true)}
                >
                  <Common_Btn text={"Get Free Event Consultation"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Solar_Modal show={showModal} handleClose={() => setShowModal(false)} />
    </section>
  );
};

export default Free_Consultation;